import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad details
 */
export class AdDetailsAggregate extends ValueObject {
  /**
   * @param {Object} deps
   * @param {AdEntity} deps.ad
   * @param {AdStatsValueObject} deps.adStats
   * @param {AdTypeValueObject} deps.adType
   * @param {AdListValueObjectLegacy} deps.recommendedAds
   * @param {boolean} deps.isRecommendedAdsFallback
   * @param {Boolean} deps.isTradable
   * @param {ReservationEntity} deps.reservation
   * @param {SellerValueObject} deps.seller
   * @param {String} deps.status
   * @param {VehicleCertificationValueObject} deps.vehicleCertification
   * @param {VehicleDataValueObject} deps.vehicleData
   * @param {VehicleHistoryValueObject} deps.vehicleHistory
   * @param {VehicleInfoValueObject} deps.vehicleInfo
   */

  getAd() {
    return this._ad
  }

  getAdStats() {
    return this._adStats
  }

  getAdType() {
    return this._adType
  }

  getFinancingData() {
    return this._financingData
  }

  getIsTradable() {
    return this._isTradable
  }

  getReservation() {
    return this._reservation
  }

  getSeller() {
    return this._seller
  }

  getStatus() {
    return this._status
  }

  getVehicleCertification() {
    return this._vehicleCertification
  }

  getVehicleHistory() {
    return this._vehicleHistory
  }

  getVehicleData() {
    return this._vehicleData
  }

  getRecommendedAds() {
    return this._recommendedAds
  }

  isRecommendedAdsFallback() {
    return this._isRecommendedAdsFallback
  }

  hasRecommendedAds() {
    return Boolean(this._recommendedAds)
  }

  getVehicleInfo() {
    return this._vehicleInfo
  }

  get hasVehicleHistory() {
    return Boolean(this._vehicleHistory)
  }

  toJSON() {
    return {
      ad: this._ad.toJSON(),
      adStats: this._adStats.toJSON(),
      adType: this._adType.toJSON(),
      financingData: this._financingData ? this._financingData.toJSON() : undefined,
      reservation: this._reservation.toJSON(),
      seller: this._seller.toJSON(),
      status: this._status,
      vehicleCertification: this._vehicleCertification.toJSON(),
      ...(this._isTradable && {isTradable: this._isTradable.toJSON()}),
      ...(this._vehicleHistory && {vehicleHistory: this._vehicleHistory.toJSON()}),
      ...(this._recommendedAds && {recommendedAds: this._recommendedAds.toJSON()}),
      ...(this._isRecommendedAdsFallback && {isRecommendedAdsFallback: this._isRecommendedAdsFallback}),
      ...this._vehicleInfo.toJSON()
    }
  }
}
